import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarItemMoveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.70001 3.36H11.37V5.83C11.37 6.18 11.65 6.45 11.99 6.45C12.33 6.45 12.61 6.17 12.61 5.83V3.36H14.28C14.59 3.36 14.77 2.99 14.56 2.75L12.47 0.219995C12.22 -0.0800049 11.77 -0.0800049 11.52 0.219995L9.41001 2.75C9.21001 2.99 9.38001 3.36 9.69001 3.36H9.70001Z"
        fill={color}
      />
      <path
        d="M14.3 20.64H12.63V18.17C12.63 17.83 12.35 17.55 12.01 17.55C11.67 17.55 11.39 17.83 11.39 18.17V20.64H9.72C9.41 20.64 9.22999 21.01 9.43999 21.25L11.55 23.78C11.8 24.08 12.25 24.08 12.5 23.78L14.61 21.25C14.81 21.01 14.64 20.64 14.33 20.64H14.3Z"
        fill={color}
      />
      <path
        d="M23.78 11.53L21.25 9.41999C21.01 9.21999 20.64 9.38999 20.64 9.69999V11.37H18.17C17.83 11.37 17.55 11.65 17.55 11.99C17.55 12.33 17.83 12.61 18.17 12.61H20.64V14.28C20.64 14.59 21.01 14.77 21.25 14.56L23.78 12.45C24.08 12.2 24.08 11.75 23.78 11.5V11.53Z"
        fill={color}
      />
      <path
        d="M5.83 11.38H3.36V9.71002C3.36 9.40002 2.99 9.22002 2.75 9.43002L0.219995 11.53C-0.0800049 11.78 -0.0800049 12.23 0.219995 12.48L2.75 14.59C2.99 14.79 3.36 14.62 3.36 14.31V12.64H5.83C6.18 12.64 6.45 12.36 6.45 12.02C6.45 11.68 6.17 11.4 5.83 11.4V11.38Z"
        fill={color}
      />
      <path
        d="M12.38 7.35C12.15 7.21 11.86 7.21 11.63 7.35L8.19001 9.35C7.96001 9.48 7.82001 9.73 7.82001 10V14C7.82001 14.27 7.96001 14.51 8.19001 14.65L11.63 16.65C11.86 16.79 12.15 16.79 12.38 16.65L15.82 14.65C16.05 14.52 16.19 14.27 16.19 14V10C16.19 9.73 16.05 9.49 15.82 9.35L12.38 7.35ZM14.69 13.57L12 15.13L9.31001 13.57V10.43L12 8.87L14.69 10.43V13.57Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarItemMoveIcon.displayName = 'ToolbarItemMoveIcon';
